(function () {
  var FEE_VARIANT_ID = 53778175394099;
  var FEE_PRICE = '+$5.99 USD';
  var HELP_TEXT = 'Maximum 10 letters, numbers, or spaces. Each character may appear up to twice.';

  function normalizeText(value) {
    var result = '';
    var counts = {};

    Array.from(value).some(function (character) {
      if (result.length >= 10) return true;
      if (!/[A-Za-z0-9 ]/.test(character)) return false;

      var key = character.toLowerCase();
      counts[key] = counts[key] || 0;
      if (counts[key] >= 2) return false;

      counts[key] += 1;
      result += character;
      return false;
    });

    return result;
  }

  function isTargetForm(form) {
    if (!form || !form.matches('form[action*="/cart/add"]')) return false;
    if (!form.matches('.shopify-product-form, .caseere-sticky-product-bar__form')) return false;

    var productInput = form.querySelector('input[name="product-id"]');
    return productInput && Boolean(productInput.value);
  }

  function getProductName() {
    var title = document.querySelector('meta[property="og:title"]');
    return title && title.content ? title.content.trim() : 'Customized product';
  }

  function setLoading(form, loading) {
    form.querySelectorAll('button[type="submit"]').forEach(function (button) {
      button.disabled = loading;
      button.toggleAttribute('aria-busy', loading);
    });
  }

  function getCartAddUrl() {
    var url = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    return /\.js(?:[?#]|$)/.test(url) ? url : url.replace(/\/+$/, '') + '.js';
  }

  function addItems(items) {
    return fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.text().then(function (body) {
        var data;

        try {
          data = JSON.parse(body);
        } catch (parseError) {
          var invalidResponseError = new Error('The store could not add the personalization. Please refresh the page and try again.');
          invalidResponseError.invalidResponse = true;
          throw invalidResponseError;
        }

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add personalization.');
        }

        return data;
      });
    });
  }

  function initialize() {
    var form = Array.from(document.querySelectorAll('form.shopify-product-form')).find(isTargetForm);
    if (!form || document.querySelector('[data-kakavy-native-personalizer]')) return false;

    var container = document.createElement('div');
    container.className = 'kakavy-native-personalizer notranslate';
    container.dataset.kakavyNativePersonalizer = 'true';
    container.setAttribute('translate', 'no');
    container.innerHTML =
      '<label class="kakavy-native-personalizer__toggle">' +
        '<input class="kakavy-native-personalizer__checkbox" type="checkbox" aria-controls="kakavy-native-personalizer-fields" aria-expanded="false">' +
        '<span class="kakavy-native-personalizer__box" aria-hidden="true"></span>' +
        '<span><span class="kakavy-native-personalizer__title">Add custom text</span>' +
        '<span class="kakavy-native-personalizer__subtitle">Debossed by hand</span></span>' +
        '<span class="kakavy-native-personalizer__price">' + FEE_PRICE + '</span>' +
      '</label>' +
      '<div class="kakavy-native-personalizer__fields" id="kakavy-native-personalizer-fields" hidden>' +
        '<label class="kakavy-native-personalizer__input-label" for="kakavy-native-personalizer-text">' +
          '<span>Enter custom text</span><span class="kakavy-native-personalizer__count">0/10</span>' +
        '</label>' +
        '<input id="kakavy-native-personalizer-text" class="kakavy-native-personalizer__input" name="properties[Custom text]" type="text" placeholder="ABC123" maxlength="10" pattern="[A-Za-z0-9 ]{1,10}" inputmode="text" autocomplete="off" aria-describedby="kakavy-native-personalizer-help kakavy-native-personalizer-error" disabled>' +
        '<p class="kakavy-native-personalizer__help" id="kakavy-native-personalizer-help">' + HELP_TEXT + '</p>' +
        '<p class="kakavy-native-personalizer__error" id="kakavy-native-personalizer-error" role="alert"></p>' +
      '</div>';

    var buttonWrapper = form.querySelector(':scope > div');
    form.insertBefore(container, buttonWrapper || form.firstChild);

    var checkbox = container.querySelector('.kakavy-native-personalizer__checkbox');
    var fields = container.querySelector('.kakavy-native-personalizer__fields');
    var input = container.querySelector('.kakavy-native-personalizer__input');
    var counter = container.querySelector('.kakavy-native-personalizer__count');
    var error = container.querySelector('.kakavy-native-personalizer__error');
    var dynamicCheckout = form.querySelector('.shopify-payment-button');
    var dynamicCheckoutDisplay = dynamicCheckout ? dynamicCheckout.style.display : '';

    function setOpen(open) {
      fields.hidden = !open;
      input.disabled = !open;
      input.required = open;
      checkbox.setAttribute('aria-expanded', open ? 'true' : 'false');
      container.classList.toggle('is-open', open);
      if (dynamicCheckout) dynamicCheckout.style.display = open ? 'none' : dynamicCheckoutDisplay;
      error.textContent = '';
      if (open) input.focus();
    }

    checkbox.addEventListener('change', function () {
      setOpen(checkbox.checked);
    });

    input.addEventListener('input', function () {
      var normalized = normalizeText(input.value);
      var changed = normalized !== input.value;
      input.value = normalized;
      counter.textContent = normalized.length + '/10';
      error.textContent = changed ? HELP_TEXT : '';
    });

    document.addEventListener('submit', function (event) {
      var submittedForm = event.target;
      if (!checkbox.checked || !isTargetForm(submittedForm)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var text = normalizeText(input.value).trim();
      if (!text) {
        error.textContent = 'Please enter custom text.';
        input.focus();
        return;
      }

      var variantInput = submittedForm.querySelector('input[name="id"]');
      var quantityInput = submittedForm.querySelector('input[name="quantity"]');
      var quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
      var customizationId = 'KAK-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);

      if (!variantInput || !variantInput.value) {
        error.textContent = 'Please select a product variant.';
        return;
      }

      setLoading(submittedForm, true);
      error.textContent = '';

      var items = [
        {
          id: Number(variantInput.value),
          quantity: quantity,
          properties: {
            'Custom text': text,
            '_Customization ID': customizationId
          }
        },
        {
          id: FEE_VARIANT_ID,
          quantity: quantity,
          properties: {
            'Custom text': text,
            'Personalization for': getProductName(),
            '_Customization ID': customizationId
          }
        }
      ];

      addItems(items)
        .catch(function (requestError) {
          if (!requestError.invalidResponse) throw requestError;
          return new Promise(function (resolve) {
            window.setTimeout(resolve, 300);
          }).then(function () {
            return addItems(items);
          });
        })
        .then(function () {
          window.location.assign(window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');
        })
        .catch(function (requestError) {
          error.textContent = requestError.message;
          setLoading(submittedForm, false);
        });
    }, true);

    return true;
  }

  function start() {
    if (initialize()) return;

    var observer = new MutationObserver(function () {
      if (initialize()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
